
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaitokohlapur() {



    const cardData =
    {
        keyword: 'Mumbai to Kolhapur Cab',
        heading: 'S9 Travels:  Mumbai to Kolhapur Cab',
        headingDescription: 'S9 Travels offers Mumbai to Kolhapur Cab Service, providing a comfortable, reliable, and hassle-free travel experience. Whether you are visiting Mahalaxmi Temple, business meetings, or exploring Kolhapur rich heritage, our Innova cabs ensure a smooth and safe journey. With spacious interiors, luxury features, and professional drivers, we guarantee a stress-free ride. Enjoy on-time pickups, affordable pricing, and 24/7 service. Book your Mumbai to Kolhapur cab with S9 Travels today for a seamless travel experience!',


        top: 'Top Places to Visit in Kohlapur with S9 Travels',

"topPlaces": [
    {
      "title": "Mahalaxmi Temple",
      "description": "One of the most famous temples in Maharashtra, Mahalaxmi Temple is dedicated to Goddess Mahalaxmi (Ambabai). It is a significant religious site and attracts thousands of devotees every year."
    },
    {
      "title": "Rankala Lake",
      "description": "A serene lake in Kolhapur, Rankala Lake is a popular spot for evening walks, boating, and relaxation. The scenic beauty and cool breeze make it a favorite among locals and tourists."
    },
    {
      "title": "Panhala Fort",
      "description": "A historic fort near Kolhapur, Panhala Fort is known for its strategic importance in Maratha history. It offers breathtaking views of the Sahyadri Hills and is a great spot for trekking."
    },
    {
      "title": "New Palace",
      "description": "Also known as Shree Chhatrapati Shahu Museum, the New Palace is a magnificent structure showcasing the rich history of Kolhapur's royal family. The museum houses artifacts, weapons, and paintings."
    },
    {
      "title": "Jyotiba Temple",
      "description": "Located on a hilltop, Jyotiba Temple is a revered pilgrimage site dedicated to Lord Jyotiba. The temple offers stunning panoramic views of the surrounding landscape."
    },
    {
      "title": "Chinmaya Ganadhish",
      "description": "A beautiful and peaceful temple dedicated to Lord Ganesha. It is a must-visit for spiritual seekers looking for a tranquil atmosphere."
    },
    {
      "title": "Dajipur Wildlife Sanctuary",
      "description": "Also known as Radhanagari Wildlife Sanctuary, this is a great place for wildlife lovers. The sanctuary is home to bison, deer, and a variety of birds."
    },
    {
      "title": "Shalini Palace",
      "description": "A stunning palace on the banks of Rankala Lake, Shalini Palace is known for its Indo-European architecture and royal grandeur."
    },
    {
      "title": "Narsinhwadi Datta Mandir",
      "description": "A famous temple dedicated to Lord Dattatreya, located on the banks of the Krishna River. It is a peaceful and spiritually significant place."
    },
    {
      "title": "Ramtirth Waterfall",
      "description": "A beautiful seasonal waterfall near Kolhapur, Ramtirth is a great spot for nature lovers and photographers. It is especially breathtaking during the monsoon."
    }
],

"services": [
    {
      "name": "Mumbai to Kolhapur Cab Service",
      "description": "S9 Travels offers reliable and comfortable cab services from Mumbai to Kolhapur. Whether you're traveling for business, leisure, or pilgrimage, our cabs ensure a safe and pleasant journey to Kolhapur."
    },
    {
      "name": "Book Mumbai to Kolhapur Taxi",
      "description": "Booking a taxi from Mumbai to Kolhapur is easy with S9 Travels. Choose from one-way or round-trip options and enjoy a comfortable ride with a professional driver."
    },
    {
      "name": "Mumbai to Kolhapur One-Way Cab",
      "description": "Planning a one-way trip from Mumbai to Kolhapur? S9 Travels provides convenient and affordable one-way cab services, ensuring a direct and hassle-free journey."
    },
    {
      "name": "Mumbai to Kolhapur Round Trip",
      "description": "S9 Travels offers round-trip cab services from Mumbai to Kolhapur, giving you the flexibility to explore Kolhapur and return comfortably."
    },
    {
      "name": "Affordable Mumbai to Kolhapur Cab",
      "description": "Looking for an affordable way to travel from Mumbai to Kolhapur? S9 Travels offers budget-friendly options without compromising on comfort, making your journey to Kolhapur easy on the wallet."
    },
    {
      "name": "Private Taxi for Kolhapur from Mumbai",
      "description": "Choose S9 Travels for a private taxi from Mumbai to Kolhapur. Enjoy a personalized and direct travel experience with professional drivers and a comfortable ride."
    },
    {
      "name": "Luxury Cab for Kolhapur Travel from Mumbai",
      "description": "Travel in style with S9 Travels' luxury cab service from Mumbai to Kolhapur. Experience premium amenities and exceptional comfort with our well-maintained luxury vehicles."
    },
    {
      "name": "Kolhapur Trip by Cab from Mumbai",
      "description": "Make your Kolhapur trip special with S9 Travels. Our well-maintained cabs and experienced drivers ensure a smooth and enjoyable journey from Mumbai to Kolhapur."
    },
    {
      "name": "Mumbai to Kolhapur Sightseeing Tour",
      "description": "Explore Kolhapur's famous landmarks with S9 Travels' sightseeing cab service. Our professional drivers will take you to the must-see attractions, making your visit to Kolhapur unforgettable."
    },
    {
      "name": "Group Travel to Kolhapur",
      "description": "Traveling with a group? S9 Travels provides spacious cabs for group travel from Mumbai to Kolhapur. Enjoy a comfortable and convenient ride for your entire group."
    },
    {
      "name": "Comfortable Taxi Service from Mumbai to Kolhapur",
      "description": "S9 Travels ensures a comfortable and relaxing taxi service from Mumbai to Kolhapur. Our experienced drivers and well-maintained vehicles ensure a pleasant and stress-free journey."
    }
],

"tableData": [
  ["Mumbai to Kolhapur Cab Service", "Book Mumbai to Kolhapur Taxi"],
  ["Mumbai to Kolhapur One-Way Cab", "Mumbai to Kolhapur Round Trip"],
  ["Affordable Mumbai to Kolhapur Cab", "Private Taxi for Kolhapur from Mumbai"],
  ["Luxury Cab for Kolhapur Travel from Mumbai", "Kolhapur Trip by Cab from Mumbai"],
  ["Mumbai to Kolhapur Sightseeing Tour", "Group Travel to Kolhapur"],
  ["Comfortable Taxi Service from Mumbai to Kolhapur", ""]
],






"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Long-Distance Travel",
    "WhyChoosedescription": "S9 Travels provides a comfortable and relaxing Mumbai to Kolhapur cab service. Our well-maintained vehicles, including the Toyota Innova, offer spacious interiors, air conditioning, and a smooth ride, ensuring that you enjoy a comfortable journey on this long-distance trip."
  },
  {
    "WhyChooseheading": "Reliable and Timely Service",
    "WhyChoosedescription": "Whether you're traveling for business, leisure, or religious purposes, our Mumbai to Kolhapur cab service ensures timely pick-ups and drop-offs. We prioritize punctuality, ensuring that you reach Kolhapur on time without any delays."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with the Route",
    "WhyChoosedescription": "Our experienced drivers are familiar with the best routes from Mumbai to Kolhapur, ensuring a smooth and efficient journey. They know the road conditions and traffic patterns, providing you with a safe and comfortable ride throughout the trip."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for the Mumbai to Kolhapur cab service. Our pricing is clear and straightforward, with no hidden charges, so you can plan your trip within your budget without any surprises."
  },
  {
    "WhyChooseheading": "Safety and Comfort on Your Journey",
    "WhyChoosedescription": "Your safety is our priority. All our cabs are equipped with modern safety features such as GPS tracking, airbags, and seat belts. Whether you're traveling alone, with family, or in a group, you can trust us to provide a safe and comfortable ride."
  },
  {
    "WhyChooseheading": "24/7 Availability for Your Travel Needs",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexibility in scheduling your Mumbai to Kolhapur trip. Whether you prefer an early morning departure or a late-night journey, we’re here to accommodate your needs and ensure you have a seamless travel experience."
  },
  {
    "WhyChooseheading": "Customizable Travel Plans for Your Trip",
    "WhyChoosedescription": "We understand that every journey is unique. S9 Travels offers customizable travel plans for your Mumbai to Kolhapur trip. Whether you need to make stops along the way or adjust your schedule, we can tailor the trip to suit your preferences."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking a Mumbai to Kolhapur cab with S9 Travels is easy and convenient. You can easily book online via our website or app, or contact our customer service team for personalized assistance. We strive to make the booking process smooth and hassle-free."
  }
]













    }


    const faqData = [
        [
          {
            question: 'How can I book a cab from Mumbai to Kolhapur with S9 Travels?',
            answer: 'Booking a cab from Mumbai to Kolhapur is easy! You can book through our website or app, or simply contact our customer service team for personalized assistance to plan your trip comfortably.',
          },
          {
            question: 'What types of vehicles are available for Mumbai to Kolhapur travel?',
            answer: 'We offer a variety of vehicles for your Mumbai to Kolhapur journey, including sedans, SUVs, and premium vehicles like the Toyota Innova, ensuring you travel in comfort and style.',
          },
          {
            question: 'How long does the journey from Mumbai to Kolhapur take?',
            answer: 'The journey from Mumbai to Kolhapur typically takes around 6 to 7 hours, depending on the traffic and road conditions. Our experienced drivers will ensure a safe, smooth, and timely arrival.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel like Mumbai to Kolhapur?',
            answer: 'Yes, all our drivers are highly experienced in long-distance travel and are familiar with the best routes to Kolhapur. They ensure your journey is safe, comfortable, and hassle-free.',
          },
          {
            question: 'Can I book a round trip for Mumbai to Kolhapur?',
            answer: 'Yes, we offer round-trip bookings for your Mumbai to Kolhapur travel. You can plan your return trip according to your schedule, and we will ensure a smooth and timely journey back to Mumbai.',
          },
          {
            question: 'Is there a fixed fare for Mumbai to Kolhapur cab service?',
            answer: 'The fare for Mumbai to Kolhapur travel varies based on the type of vehicle, trip duration, and any specific requirements you may have. Contact us for a customized quote for your trip.',
          },
          {
            question: 'Do you provide pickup from Mumbai airport or hotels for Kolhapur trips?',
            answer: 'Yes, we provide convenient pickup services from Mumbai airport or your hotel for your trip to Kolhapur. Our drivers will ensure a seamless transfer, making your journey comfortable from the start.',
          },
          {
            question: 'Can I request additional stops on the way to Kolhapur?',
            answer: 'Yes, we can accommodate any additional stops for sightseeing or breaks during your trip to Kolhapur. Simply let us know while booking, and we will make necessary arrangements for your convenience.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during the Mumbai to Kolhapur trip?',
            answer: 'Any extra charges for waiting time or detours will be communicated upfront when you book your trip. We ensure full transparency in pricing to make your trip as smooth as possible.',
          },
          {
            question: 'Why should I choose S9 Travels for my Mumbai to Kolhapur cab service?',
            answer: 'S9 Travels offers reliable, safe, and comfortable cab services for your Mumbai to Kolhapur journey. With well-maintained vehicles, experienced drivers, and excellent customer service, we ensure a smooth, timely, and enjoyable trip.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Prakash Patil',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab from Mumbai to Kolhapur with S9 Travels, and the experience was fantastic. The vehicle was clean and comfortable, and the driver was professional and experienced. The trip was smooth and timely. Highly recommend their service for long-distance travel!”',
        },
        {
          name: 'Mrs. Sunita Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our trip to Kolhapur from Mumbai was made so much easier thanks to S9 Travels. The driver was very courteous, the car was in excellent condition, and we had a smooth and safe journey. I’ll definitely choose S9 Travels again for future trips!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
     
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai to Kolhapur Cab",
        "description": "Book affordable and reliable Mumbai to Kolhapur cab services for one-way trips, round trips, luxury cabs, and group travel. S9 Travels offers private taxi rides for comfortable and scenic travel from Mumbai to Kolhapur, including sightseeing tours and hassle-free transportation.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      


    return (
        <div>
         <Helmet>
        <title>Mumbai to Kolhapur Cab | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Mumbai to Kolhapur taxi services, including one-way, round-trip, and luxury cabs. Affordable and comfortable transport for sightseeing tours, group travel, and hassle-free trips from Mumbai to Kolhapur with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/52.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitokohlapur;